/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 09:13:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-10-17 10:56:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Skeleton } from '@/src/components/Antd';
import NoPermission from '@/src/components/NoPermission';
import ModalHOC from '@/src/constrains/ModalHOC';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import { currencies } from '@/src/request/currency';
import {
  init_gateways,
  init_paymentData,
  save_paymentData,
} from '@/src/request/salesChannel/setting/payment';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { paymentGatewayProvider } from '@/src/types/common/paymentGateway';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import _ from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Import from 'src/constrains/Import';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { ChannelType } from 'src/types/common/SalesChannel';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import AdvancedSettings from './AdvancedSettings';
import AvailablePaymentGateways from './AvailablePaymentGateways';
import BankTransferDetails from './BankTransferDetails';
import SelectPaymentGatewayModal from './components/SelectPaymentGatewayModal';
import {
  breadcrumbData,
  translateCurrencies,
  translateGateways,
} from './config';
import CurrencyConversion from './CurrencyConversion';
import DomainRegistration from './DomainRegistration';
import {
  useCurrencyEffect,
  useEnableThird,
  useMethodsList,
} from './hooks/useMethodsList';
import ProcessingFee from './ProcessingFee';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { get } from 'lodash';

const permissions = (uuid: string) => {
  const view_payment_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelPayment,
        operation: EnumOperation.view_payment_settings,
        uuid,
      }),
    ],
  });
  const edit_payment_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelPayment,
        operation: EnumOperation.edit_payment_setting,
        uuid,
      }),
    ],
  });

  return {
    view_payment_settings,
    edit_payment_setting,
  };
};

const SalesChannelPayment = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { modalOp, isPrimary } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const channelType = useSalesChannelType();
  const isMini = channelType == ChannelType.MiniProgram;
  const [form] = Form.useForm();

  const params: any = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const [paymentGateway, setPaymentGateway] = useState([]);
  const [currenciesList, setCurrenciesList] = useState([]);
  const [currencyConversion, setCurrencyConversion] = useState([]);
  const [gatewayList, setGatewayList] = useState([]);
  const [methodsList, setMethodsList] = useState([]);
  const [enableThirdPartyCurrency, setEnableThirdPartyCurrency] =
    useState(false);
  const [formData, setFormData] = useState<any>({});
  const [primaryCurrency, setPrimaryCurrency] = useState('');
  const [lastUploadDate, setLastUploadDate] = useState('');
  const [applePayRegistration, setApplePayRegistration] = useState('');
  const [salesChannelName, setSalesChannelName] = useState('');
  const [uuid, setUuid] = useState('');

  const { uuid: salesChannelUuid } = params;

  const { view_payment_settings, edit_payment_setting } =
    permissions(salesChannelUuid);
  const currencyCodesAll = [
    { code: primaryCurrency, primaryCurrency: true },
    ...currencyConversion,
  ];

  // const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
  //   lastSecond: 'Setting',
  //   lastOne: 'Payment',
  // });

  useEffect(() => {
    if (view_payment_settings) {
      const initPaymentData = init_paymentData(salesChannelUuid, {
        [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
      });
      const getCurrencies = currencies();
      const initGateways = init_gateways(salesChannelUuid, []);
      Promise.all([getCurrencies, initPaymentData, initGateways]).then(
        (res: any) => {
          const currenciesData = res[0] || '';
          const { bankTransferInstruction, enableProcessingFee } = res[1];
          setCurrenciesList(currenciesData);
          setPaymentGateway(res[1].availablePaymentGateways || []);
          setLastUploadDate(res[1].lastUploadDate);
          setApplePayRegistration(res[1].applePayRegistration);
          setPrimaryCurrency(res[1].primaryCurrencyCode);
          setFormData({ bankTransferInstruction, enableProcessingFee });
          setSalesChannelName(res[1].salesChannelName || '');
          setEnableThirdPartyCurrency(res[1].enableCurrencyConversion);
          const currencyAll = (res[1].currencyCodes || []).map((currency) =>
            currenciesData.find((c) => c.code == currency),
          );
          setCurrencyConversion(currencyAll);
          setUuid(res[1].uuid);
          const gatewayData = res[2] || '';
          setGatewayList(gatewayData);
          setLoading(false);
        },
      );
    }
  }, []);

  useMethodsList((value) => {
    setMethodsList(value);
  }, paymentGateway);

  useEnableThird(
    setCurrencyConversion,
    setMethodsList,
    methodsList,
    primaryCurrency,
    enableThirdPartyCurrency,
  );
  useCurrencyEffect(setMethodsList, methodsList, currencyConversion);

  const updatePage = () => {
    init_paymentData(salesChannelUuid).then((data) => {
      setLastUploadDate(data.lastUploadDate);
      setApplePayRegistration(data.applePayRegistration);
    });
  };

  const onFinish = (values) => {
    if (edit_payment_setting) {
      const paymentGatewayCopy = _.cloneDeep(paymentGateway);
      methodsList.forEach((method, index) => {
        method.displayOrder = index + 1;
      });
      paymentGatewayCopy.forEach((payment) => {
        payment.salesChannelPaymentMethods.forEach((item, i) => {
          const obj = methodsList.find(
            (o) =>
              o.storeGatewayProviderUuid == item.storeGatewayProviderUuid &&
              o.paymentMethodVO.paymentMethodCode ==
                item.paymentMethodVO.paymentMethodCode,
          );
          item.displayOrder = (obj || {}).displayOrder;
          item.chargeableCurrencyList = (obj || {}).chargeableCurrencyList;
        });
      });

      const data = {
        ...values,
        uuid,
        salesChannelUuid,
        primaryCurrency,
        availablePaymentGateways: paymentGatewayCopy,
        applePayRegistration,
        lastUploadDate,
        enableCurrencyConversion: enableThirdPartyCurrency,
        currencyCodes: currencyConversion.map((currency) => currency.code),
      };
      save_paymentData(salesChannelUuid, data, {
        [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
      }).then(() => {
        message.success(getI18n('general.savesuccess'));
        setHasModified(false);
      });
    }
  };

  const goBackToList = () => {
    history.push({
      pathname: `/salesChannel/settings/${salesChannelUuid}`,
    });
  };
  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData(salesChannelName, salesChannelUuid, {
        getI18n,
      })}
    />
  );

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => form.submit()}
      onSaveDisable={!hasModified || !edit_payment_setting}
      {...(isMini
        ? {}
        : {
            extraLeft: (
              <div style={{ marginRight: 8 }}>
                <MultiLangDropDown
                  hasModified={hasModified}
                  salesChannelUuidKey='uuid'
                  customType={EnumMultiLanguageType.SalesChannelSettingsPayment}
                />
              </div>
            ),
          })}
    />
  );
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleEnableThird = (value: boolean) => {
    const methodsListCopy = _.cloneDeep(methodsList);
    setEnableThirdPartyCurrency(value);
    if (value) {
      methodsListCopy.forEach((method) => {
        method['chargeableCurrencyList'] = [
          {
            currencyCode: primaryCurrency,
            primaryCurrency: true,
            enabled: false,
          },
        ];
      });
    } else {
      setCurrencyConversion([]);
      methodsListCopy['chargeableCurrencyList'] = [];
    }
    setHasModified(true);
    setMethodsList(methodsListCopy);
  };

  //新增PaymentGateway
  const onPaymentGatewayConfirm = (value, check) => {
    const paymentGatewayCopy = _.cloneDeep(paymentGateway);
    value.salesChannelPaymentMethods = value.salesChannelPaymentMethods
      .filter((o) => {
        o.chargeableCurrencyList = currencyCodesAll.map((currency) => ({
          currencyCode: currency.code,
          primaryCurrency: false,
          enabled: false,
        }));
        return check.includes(o.paymentMethodVO.paymentMethodCode);
      })
      .map((i) => {
        return { ...i, selected: true };
      });

    paymentGatewayCopy.push(value);
    setPaymentGateway(paymentGatewayCopy);
    handleCloseModal();
    setHasModified(true);
  };

  const handleSelectPaymentGateway = () => {
    setShowModal(true);
    setModalTitle(getI18n('salesChannelPayment.index.selectPaymentGateway'));
    setModalContent(
      <SelectPaymentGatewayModal
        handleCloseModal={handleCloseModal}
        notFoundContent={getI18n(
          'salesChannelPayment.index.selectPaymentGatewayTip',
        )}
        options={translateGateways(gatewayList, paymentGateway)}
        onConfirm={onPaymentGatewayConfirm}
      />,
    );
  };

  //修改PaymentGateway
  const onEditConfirm = (value, check) => {
    const valueCopy = _.cloneDeep(value);
    valueCopy.salesChannelPaymentMethods = valueCopy.salesChannelPaymentMethods
      .filter((o) => check.includes(o.paymentMethodVO.paymentMethodCode))
      .map((i) => {
        return { ...i, selected: true };
      });

    const paymentGatewayCopy = paymentGateway.map((item) =>
      item.uuid == valueCopy.uuid ? valueCopy : item,
    );
    setPaymentGateway(paymentGatewayCopy);
    handleCloseModal();
    setHasModified(true);
  };
  const editPaymentGateway = (record) => {
    //格式化数据
    const gatewayListOriginal = gatewayList.filter(
      (gateway) => gateway.uuid == record.uuid,
    );
    gatewayListOriginal[0].labelText = (
      <Fragment>
        <div> {record.paymentGatewayName || ''}</div>
        <div>
          {record.gatewayProviderName || ''}
          {(record.remarks && `|${record.remarks}`) || ''}
        </div>
      </Fragment>
    );
    gatewayListOriginal[0].value = record.uuid;
    const defaultCheckedUuids = record.salesChannelPaymentMethods
      .filter((v) => !!v.selected)
      .map((item) => item.paymentMethodVO.paymentMethodCode);
    setShowModal(true);
    setModalTitle(getI18n('salesChannelPayment.index.editPaymentGateway'));
    setModalContent(
      <SelectPaymentGatewayModal
        handleCloseModal={handleCloseModal}
        notFoundContent={getI18n(
          'salesChannelPayment.index.selectPaymentGatewayTip',
        )}
        options={translateGateways(gatewayListOriginal, [])}
        onConfirm={onEditConfirm}
        isEdit
        defaultValue={gatewayListOriginal[0]}
        defaultCheck={defaultCheckedUuids}
      />,
    );
  };

  //新增、修改文件
  const importOnSuccess = () => {
    updatePage();
    handleCloseModal();
  };

  const handleUploadFile = () => {
    setShowModal(true);
    setModalContent(
      <Import
        onCancel={handleCloseModal}
        onSuccess={importOnSuccess}
        uploadUrl={`/portal/salesChannel/${salesChannelUuid}/upload`}
        modalOkText={getI18n('general.import')}
        formDataKey={'file'}
        accept='/*'
        hideSampleDownload
      />,
    );
    setModalTitle(getI18n('salesChannelPayment.index.importTranslations'));
  };

  //新增Currency
  const onCurrencyConfirm = (value) => {
    const currencyConversionCopy = _.cloneDeep(currencyConversion);
    currencyConversionCopy.push(value);
    setCurrencyConversion(currencyConversionCopy);
    handleCloseModal();
    setHasModified(true);
  };

  const handleSelectCurrency = () => {
    setShowModal(true);
    setModalContent(
      <SelectPaymentGatewayModal
        handleCloseModal={handleCloseModal}
        options={translateCurrencies(currenciesList, currencyConversion, {
          getI18n,
        })}
        notFoundContent={getI18n('salesChannelPayment.index.selectCurrencyTip')}
        onConfirm={onCurrencyConfirm}
      />,
    );
    setModalTitle(
      getI18n('salesChannelPayment.index.selectAdditionalChargeCurrency'),
    );
  };

  const deletePaymentGateway = (record) => {
    const paymentGatewayFilter = paymentGateway.filter(
      (o) => o.uuid !== record.uuid,
    );
    setPaymentGateway(paymentGatewayFilter);
    setHasModified(true);
  };

  /**
   * currency删除操作
   * @param record
   */
  const currencyCodeDelete = (record) => {
    const currencyCodeFilter = currencyConversion.filter(
      (o) => (o || {}).code !== (record || {}).code,
    );
    setCurrencyConversion(currencyCodeFilter);
    setHasModified(true);
  };
  /**
   * method列表的勾选操作
   */
  const currencyCheck = (record, code) => {
    const methodsListCopy = _.cloneDeep(methodsList);
    methodsListCopy.forEach((item) => {
      if (
        item.storeGatewayProviderUuid == record.storeGatewayProviderUuid &&
        item.paymentMethodVO.paymentMethodCode ==
          record.paymentMethodVO.paymentMethodCode
      ) {
        item.chargeableCurrencyList.forEach((currency) => {
          if (currency.currencyCode == code) {
            currency.enabled = !currency.enabled;
          }
        });
      }
    });
    setMethodsList(methodsListCopy);
    setHasModified(true);
  };

  const onTableChange = (value) => {
    setMethodsList(value);
    setHasModified(true);
  };

  const paymentProviderList = paymentGateway.map(
    (item) => item.gatewayProviderCode,
  );

  const child = [
    isPrimary && {
      child: (
        <AvailablePaymentGateways
          paymentGatewaysList={paymentGateway}
          isMini={isMini}
          handleSelectPaymentGateway={handleSelectPaymentGateway}
          deleteFun={deletePaymentGateway}
          editFun={editPaymentGateway}
          disableEdit={!edit_payment_setting}
        />
      ),
    },
    isPrimary &&
      !isMini && {
        child: (
          <DomainRegistration
            lastUploadDate={lastUploadDate}
            applePayRegistration={applePayRegistration}
            handleUploadFile={handleUploadFile}
            disableEdit={!edit_payment_setting}
          />
        ),
      },
    paymentProviderList.includes(paymentGatewayProvider.BANK_TRANSFER) && {
      child: (
        <BankTransferDetails
          isPrimary={isPrimary}
          disableEdit={!edit_payment_setting}
        />
      ),
    },
    isPrimary &&
      !isMini && {
        child: (
          <CurrencyConversion
            enableThirdPartyCurrency={enableThirdPartyCurrency}
            setEnableThirdPartyCurrency={handleEnableThird}
            currencyConversion={currencyConversion}
            deleteFun={currencyCodeDelete}
            handleSelectCurrency={handleSelectCurrency}
            disableEdit={!edit_payment_setting}
          />
        ),
      },
    isPrimary &&
      !isMini && {
        child: (
          <AdvancedSettings
            methodsList={methodsList}
            currencyCodes={currencyCodesAll}
            enableThirdPartyCurrency={enableThirdPartyCurrency}
            primaryCurrency={primaryCurrency}
            currencyCheck={currencyCheck}
            onTableChange={onTableChange}
            disableEdit={!edit_payment_setting}
          />
        ),
      },
    isMini && {
      child: <ProcessingFee disableEdit={!edit_payment_setting} />,
    },
  ];

  const { bankTransferInstruction = '', enableProcessingFee = false } =
    formData;
  return view_payment_settings ? (
    <Skeleton loading={loading} active>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <Form
        name='salesChannelPayment'
        form={form}
        onFinish={onFinish}
        onFinishFailed={(v) => {
          const firstErrNamePath = get(v, 'errorFields.0.name');
          form.scrollToField(firstErrNamePath, {
            behavior: 'smooth',
            block: 'center',
          });
        }}
        initialValues={{ bankTransferInstruction, enableProcessingFee }}
        onValuesChange={() => {
          setHasModified(true);
        }}>
        <Layout elements={child} topLeft={topLeft} topRight={topRight}></Layout>
      </Form>
    </Skeleton>
  ) : (
    <NoPermission />
  );
};

export default SalesChannelModeAccessControlHOC(
  SalesChannelHOC(SelectHOC(ModalHOC(SalesChannelPayment)), {
    type: EnumMultiLanguageType.SalesChannelSettingsPayment,
  }),
);
